let _warned = false;

const template = document.createElement("template");

template.innerHTML = `
<style>
  :host{
    --ctl-gap-xs: var(--ctl-spacing-xs, 8px);
    --ctl-gap-sm: var(--ctl-spacing-sm, 12px);
    --ctl-gap-md: var(--ctl-spacing-md, 16px);
    --ctl-gap-lg: var(--ctl-spacing-lg, 24px);
    --ctl-gap-xl: var(--ctl-spacing-xl, 32px);

    display:flex;
    flex-direction: row;
    gap: var(--_gap, var(--ctl-gap-md));
    align-items: var(--_align, center);
    justify-content: var(--_justify, flex-start);
    flex-wrap: var(--_wrap, wrap);
    min-width: 0;
  }

  /* Make sure children can shrink when inside toolbars/topbars */
  ::slotted(*){ min-width: 0; }

  /* gap */
  :host([gap="xs"]){ --_gap: var(--ctl-gap-xs); }
  :host([gap="sm"]){ --_gap: var(--ctl-gap-sm); }
  :host([gap="md"]){ --_gap: var(--ctl-gap-md); }
  :host([gap="lg"]){ --_gap: var(--ctl-gap-lg); }
  :host([gap="xl"]){ --_gap: var(--ctl-gap-xl); }

  /* align */
  :host([align="start"]){ --_align: flex-start; }
  :host([align="center"]){ --_align: center; }
  :host([align="end"]){ --_align: flex-end; }
  :host([align="stretch"]){ --_align: stretch; }

  /* justify */
  :host([justify="start"]){ --_justify: flex-start; }
  :host([justify="center"]){ --_justify: center; }
  :host([justify="end"]){ --_justify: flex-end; }
  :host([justify="between"]){ --_justify: space-between; }

  /* wrap */
  :host([wrap]){ --_wrap: wrap; }
  :host(:not([wrap])){ --_wrap: nowrap; }
</style>

<slot></slot>
`;

export class CtlInline extends HTMLElement {
  static get observedAttributes() {
    return ["gap", "align", "justify", "wrap"];
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(template.content.cloneNode(true));
  }

  connectedCallback() {
    // defaults (per manifest)
    if (!this.hasAttribute("gap")) this.setAttribute("gap", "md");
    if (!this.hasAttribute("align")) this.setAttribute("align", "center");
    if (!this.hasAttribute("justify")) this.setAttribute("justify", "start");

    if (!_warned) {
      _warned = true;
      console.warn(
        "[ctl-inline] is deprecated. Use the CSS utility class .ctl-inline instead.\n" +
        "  Migration: <ctl-inline gap=\"md\" justify=\"between\">  →  <div class=\"ctl-inline ctl-gap-md ctl-justify-between\">\n" +
        "  See the layout utilities documentation for details."
      );
    }
  }

  attributeChangedCallback() {
    // no-op: CSS does the work
  }

  // Convenience props (optional but helpful)
  get gap() { return this.getAttribute("gap") || "md"; }
  set gap(v) { this.setAttribute("gap", String(v || "md")); }

  get align() { return this.getAttribute("align") || "center"; }
  set align(v) { this.setAttribute("align", String(v || "center")); }

  get justify() { return this.getAttribute("justify") || "start"; }
  set justify(v) { this.setAttribute("justify", String(v || "start")); }

  get wrap() { return this.hasAttribute("wrap"); }
  set wrap(v) { v ? this.setAttribute("wrap", "") : this.removeAttribute("wrap"); }
}

customElements.define("ctl-inline", CtlInline);
